import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { t } from '../../i18n/translate.js';
import colors from '../../styles/export.module.scss.js';
import Button from '../../components/Button/Button.js';
import '../../components/AppLogo/AppLogo.js';
import '../../components/Avatar/Avatar.js';
import '../../components/Input/Input.js';
import '../../components/Input/PasswordInput.js';
import Icon from '../../components/Icon/Icon.js';
import '../../components/Image/Image.js';
import 'classnames';
import '../../components/LoadingSpinner/LoadingSpinner.module.scss.js';
import '../../components/Note/Note.js';
import '../../components/RadioButton/RadioButton.js';
import '../../components/RoundButton/RoundButton.js';
import '../../components/RoundButton/RoundButtonElement/RoundButtonElement.js';
import '../../components/Expandable/Expandable.js';
import '../../components/PopOver/PopOver.js';
import '../../components/Wizard/Wizard.js';
import '../../components/Wizard/WizardStepContent/WizardStepContent.js';
import '../../components/Wizard/NavigationBar/NavigationBar.js';
import '../../components/ToggleButton/ToggleButton.js';
import '../../components/ToggleButton/ToggleButtonElement/ToggleButtonElement.js';
import ProgressBar from '../../components/Wizard/ProgressBar/ProgressBar.js';
import '../../components/Checkbox/Checkbox.js';
import '../../components/SelectionField/SelectionField.js';
import '../../components/Card/Card.js';
import '../../components/Badge/Badge.js';
import '../../components/SettingsItem/SettingsItem.js';
import '../../components/SortableList/SortableList.js';
import '../../components/Contacts/ContactItem.js';
import '../../components/TopElement/TopElement.js';
import '../../components/SidePanelInfoBox/SidePanelInfoBox.js';
import '../../components/Flag/Flag.js';
import '../../i18n/i18n.js';
import '../../services/apiEndpoint/apiEndpoint.js';
import '../../services/appConstants/appConstants.js';
import '../../node_modules/tslib/tslib.es6.js';
import 'react-ga4';
import '../../services/utilities/countries.js';
import '@sentry/react';
import '@apollo/client';
import '@apollo/client/link/batch-http';
import '@apollo/client/link/error';
import 'uuid';
import '../../services/graphql/default-client/DefaultClient.js';
import 'axios';
import 'date-fns/isAfter';
import 'date-fns/addMinutes';
import '../../services/logout/rest-default-client/restDefaultClient.js';
import '../../services/poller/PollManager.js';
import 'react-dom';
import '../../services/ipcWeb/IpcContext.js';
import 'js-cookie';
import 'react-i18next';
import '../../services/translation/translationUtils.module.scss.js';
import '../../services/utilities/languageUtil.js';
import '../../services/useContactUs/ContactUs.gql.js';
import '../../services/storageHandler/StorageHandler.js';
import '../../services/abortablePromise/AbortablePromise.js';
import '../../services/abortablePoller/AbortablePoller.js';
import '../../services/abortablePoller/ResumablePoller.js';
import '../../components/DropDownBox/DropDownBox.module.scss.js';
import '../../components/PhoneSelectButton/PhoneSelectButton.module.scss.js';
import '../../components/InternationalPhonePicker/InternationalPhonePicker.module.scss.js';
import '../../components/Carousel/ImageCarousel.module.scss.js';
import styles from './FirmwareUpgrade.module.scss.js';
import { useFirmwareUpgrade } from './logic/useFirmwareUpgrade.js';

var FirmwareUpgrade = function FirmwareUpgrade(_ref) {
  var instance = _ref.instance;
  var panel = instance.panel,
    onNext = instance.onNext,
    giid = instance.giid,
    removeSubPanel = instance.removeSubPanel,
    client = instance.client,
    isUpgradingGateway = instance.isUpgradingGateway;
  var _useFirmwareUpgrade = useFirmwareUpgrade(giid, client),
    success = _useFirmwareUpgrade.success,
    failure = _useFirmwareUpgrade.failure,
    isPolling = _useFirmwareUpgrade.isPolling,
    percentage = _useFirmwareUpgrade.percentage,
    upgradeState = _useFirmwareUpgrade.upgradeState,
    warning = _useFirmwareUpgrade.warning,
    error = _useFirmwareUpgrade.error,
    retryUpgrade = _useFirmwareUpgrade.retryUpgrade;
  var dispatch = useDispatch();
  var closeModal = function closeModal() {
    dispatch(removeSubPanel(panel));
  };
  var compositeOnNext = function compositeOnNext() {
    onNext();
    closeModal();
  };
  var displayMainText = function displayMainText() {
    if (success) {
      return t('MPLIB_FIRMWARE_SUCCESS_TITLE');
    }
    if (failure) {
      return t('MPLIB_FIRMWARE_FAILED_TITLE');
    }
    return t('MPLIB_FIRMWARE_UPGRADE_WAITING');
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles.contentWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.toptext
  }, /*#__PURE__*/React.createElement("div", {
    id: "firmwareUpgradeSubpanel",
    className: styles.header
  }, t('MPLIB_FIRMWARE_UPGRADE_TITLE')), /*#__PURE__*/React.createElement("article", {
    className: styles.upgrade
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.air
  }, " ", displayMainText()), /*#__PURE__*/React.createElement(ProgressBar, {
    progress: percentage
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.states
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.withicon
  }, /*#__PURE__*/React.createElement("span", null, " ", upgradeState), (success || failure) && /*#__PURE__*/React.createElement(Icon, {
    dataTestId: "deviceCheckmark",
    className: styles.checkmark,
    icon: success ? 'icon-checkmark' : 'icon-warning',
    size: "medium",
    color: success ? colors.green : colors.red
  })), /*#__PURE__*/React.createElement("span", null, failure ? t('MPLIB_ERROR') : "".concat(percentage, " %"))), isPolling && !warning && (isUpgradingGateway ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: styles.airleft
  }, t('MPLIB_FIRMWARE_INSTALLING_GATEWAY_INFO_1')), /*#__PURE__*/React.createElement("p", {
    className: styles.airleft
  }, t('MPLIB_FIRMWARE_INSTALLING_GATEWAY_INFO_2'))) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: styles.airleft
  }, t('MPLIB_FIRMWARE_INSTALLING_INFO_1')), /*#__PURE__*/React.createElement("p", {
    className: styles.airleft
  }, t('MPLIB_FIRMWARE_INSTALLING_INFO_2')))), success && /*#__PURE__*/React.createElement("p", {
    className: styles.airleft
  }, t('MPLIB_FIRMWARE_INSTALLING_DONE_INFO_1')), warning && /*#__PURE__*/React.createElement("li", {
    className: styles.airleft
  }, warning), failure && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: styles.airleft
  }, t('MPLIB_FIRMWARE_INSTALLING_FAILURE_INFO_1')), /*#__PURE__*/React.createElement("li", {
    className: styles.airleft
  }, error), /*#__PURE__*/React.createElement("p", {
    className: styles.airleft
  }, t('MPLIB_FIRMWARE_INSTALLING_FAILURE_TRY_AGAIN'))))), /*#__PURE__*/React.createElement("div", {
    className: styles.optionButtons
  }, failure && /*#__PURE__*/React.createElement(Button, {
    className: styles.optionButton,
    flat: true,
    cancel: true,
    text: t('MPLIB_CLOSE'),
    onClick: closeModal
  }), /*#__PURE__*/React.createElement(Button, {
    dataTestId: "confirmFU",
    className: styles.optionButton,
    text: failure ? t('MPLIB_RETRY') : t('MPLIB_NEXT'),
    onClick: failure ? retryUpgrade : compositeOnNext,
    disabled: isPolling,
    flat: true
  })));
};
FirmwareUpgrade.propTypes = {
  instance: PropTypes.shape({
    onNext: PropTypes.func.isRequired,
    panel: PropTypes.string.isRequired,
    giid: PropTypes.string.isRequired,
    removeSubPanel: PropTypes.func.isRequired,
    client: PropTypes.shape({
      query: PropTypes.func.isRequired,
      mutate: PropTypes.func.isRequired
    }).isRequired,
    isUpgradingGateway: PropTypes.bool.isRequired
  }).isRequired
};
FirmwareUpgrade.defaultProps = {};

export { FirmwareUpgrade as default };
